import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "More Fun with Projections",
description: "Explore advanced Freon editor projections—build tables, define multiple editor views, control precedence, and target specific projections for concepts like FlowRule and PageTransition.",
tags: [ "Freon", "projectional editing", "editor", "projections", "tables", "Flow", "FlowRule", "PageTransition", "rules_as_table", "footing editor", "multiple editors", "editor precedence", "Education language", "tutorial"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};